// extracted by mini-css-extract-plugin
module.exports = {"parent":"MarketBanner_parent__tdL9J","main":"MarketBanner_main__VAQMq","flexButton":"MarketBanner_flexButton__Ovzg0","image":"MarketBanner_image__LR_pF"};